import React from "react";
import { Link } from "react-router";
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarLeftExpand,
} from "react-icons/tb";

interface SidebarHeaderProps {
  isCollapsed?: boolean;
  isLocked?: boolean;
  onToggleLock?: () => void;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  isCollapsed = false,
  isLocked = false,
  onToggleLock,
}) => {
  return (
    <div
      className={`flex items-center border-b border-[var(--arc-sidebar-border-accent)] ${
        isCollapsed ? "justify-center px-2 py-3" : "justify-between px-4 py-3"
      }`}
    >
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2">
        <div
          className={`flex items-center rounded-lg bg-[var(--arc-sidebar-accent-glow)] hover:bg-[rgba(var(--arc-accent-rgb),0.2)] transition-all hover:scale-105 active:scale-95 ${
            isCollapsed ? "p-2" : "gap-2 px-2 py-1.5"
          } ${isLocked ? "arc-sidebar-item-active-collapsed" : ""}`}
        >
          <img
            src="/logo.webp"
            alt="Crowlingo"
            className="w-6 h-6 object-contain"
          />
          {!isCollapsed && (
            <span className="font-loom text-sm font-bold text-[var(--arc-sidebar-text-primary)] whitespace-nowrap">
              Crowlingo
            </span>
          )}
        </div>
      </Link>

      {/* Lock/Unlock button */}
      {!isCollapsed && onToggleLock && (
        <button
          onClick={onToggleLock}
          className={`p-1.5 rounded-md transition-all hover:bg-[var(--arc-sidebar-accent-glow)] ${
            isLocked ? "text-[var(--arc-accent)]" : "text-[var(--arc-sidebar-text-secondary)] hover:text-[var(--arc-sidebar-text-primary)]"
          }`}
          title={
            isLocked ? "Auto-collapse sidebar" : "Keep sidebar open"
          }
        >
          {isLocked ? (
            <TbLayoutSidebarLeftExpand className="w-4 h-4" />
          ) : (
            <TbLayoutSidebarLeftCollapse className="w-4 h-4" />
          )}
        </button>
      )}
    </div>
  );
};

SidebarHeader.displayName = "SidebarHeader";

export default SidebarHeader;
